import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import { EXECUTIVE_PATHS } from 'lumen/utils/spider';

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({ features: ['app.market.spider'] })
export default class MarketExecutiveIndexRoute extends Route {
  @service declare router: Services['router'];

  redirect(): void {
    this.router.replaceWith(
      'market.executive.spider-dashboard',
      EXECUTIVE_PATHS[0],
    );
  }
}
